import {waitUntil} from 'async-wait-until';
import {isInView} from 'isinview';
import * as MapStyles from '../util/map-styles'; 
if (!customElements.get('map-object')) {
  class MapObject extends HTMLElement {
    constructor() {

      super();

      // Status
      this.apiStatus = null;
      this.apiKeyReset = false;

      // Map customization options
      this.apiKey = this.dataset.apiKey;
      this.addressSetting = this.dataset.addressSetting;
      this.config = {
        zoom: 14,
        disableDefaultUI: true,
        styles: MapStyles.styles[this.dataset.mapStyle],
      };

      // Errors
      this.errors = {
        addressNoResults: window.theme.strings.addressNoResults,
        addressQueryLimit: window.theme.strings.addressQueryLimit,
        addressError: window.theme.strings.addressError,
        authError: window.theme.strings.authError,
      };

      this.userInteractionInit();
    }

    async userInteractionInit() {
      try {
        await waitUntil(() => theme.userInteraction === true, {
          timeout: 4000,
        });
      } catch(error) {
        theme.userInteraction = true;
      }

      // User never interacted after 10s, continue
      isInView(this, (target) => {
        this.initGoogleMaps();
      }, {
        once: true,
      });
    }

    async initGoogleMaps() {
      // Google Maps failure
      window.gm_authFailure = () => {
        this.errorMessage(this.errors.authError);
        theme.googleMapsApiStatus = null;
      }

      if (theme.googleMapsApiStatus === 'loaded') {
        this.createMap();
      } else {
        // Load GM api and wait until done
        if (theme.googleMapsApiStatus !== 'loading') {
          theme.googleMapsApiStatus = 'loading';

          const script = document.createElement('script');
          script.id = `gm-${this.id}`;
          script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}`;
          script.async = true;
          script.onload = () => {
            theme.googleMapsApiStatus = 'loaded';
            this.createMap();
          };
          document.body.append(script);
        } else {
          // In case more than one map section might be attempting to load
          await waitUntil(() => theme.googleMapsApiStatus === 'loaded');
          this.createMap();
        }
      }

      
    }

    createMap() {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: this.addressSetting}, (results, status) => {
        if (status === "OK") {     
          const map = new google.maps.Map(this, {
            center: results[0].geometry.location,
            ...this.config
          });

          new google.maps.Marker({
            map: map,
            position: results[0].geometry.location,
          });

        } else {
          if (!Shopify.designMode) {
            this.errorMessage(
              `Geocode was not successful for the following reason - ${status}`
            );
            return;
          }

          let errorMessage;
          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = this.errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = this.errors.addresQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = this.errors.authError;
              break;
            default:
              errorMessage = this.errors.addressError;
              break;
          }

          this.errorMessage(errorMessage);
        }
      });
    }

    errorMessage(message) {
      console.warn(`Google Maps Error: ${message}`);

      if (Shopify.designMode) {
        const errorElement = document.createElement('p');
        errorElement.appendChild(document.createTextNode(message));
        errorElement.classList.add('map__error-message', 'error-message');

        this.appendChild(errorElement);
      }
    }

  }

  customElements.define('map-object', MapObject);
}